<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
  import TnkcBanner from '@/assets/tnkc-banner.png';

  export default {
    name: 'Dashboard',
    data() {
      return {
        tnkcBanner: TnkcBanner,
      };
    },
  };
</script>

<style scoped>

</style>